module.exports = __webpack_public_path__ + "media/images/emblems/Wolhusen_LU-0f114419fe5f84b7aae6c65b1b578994.png";